/**
 * Normalizes user-provided free text used for Maps lookups and caching.
 *
 * Goal: increase cache hit rate for semantically identical input while keeping
 * behavior predictable (no locale-specific folding beyond lowercasing).
 */
export function normalizeMapsFreeText(input: string): string {
  return input.trim().replace(/\s+/g, " ").toLowerCase();
}

